import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/settings/integrations/strava",
)({
  component: Outlet,
});
